import PropTypes from 'prop-types';
import { Button } from '../../../../../modules/infra/ui/button';
import Icon, { GLYPHS } from '../../../../common/icon';

const WalkInListHeader = ({ onClose, onSettingsClick, onAddWalkIn }) => {
  return (
    <div className="walk-in-list-header">
      <div className="walk-in-list-header-top">
        <button type="button" className="walk-in-list-close" onClick={onClose} aria-label="Close walk-in list">
          ✕
        </button>
      </div>
      <div className="walk-in-list-separator" />
      <div className="walk-in-list-header-main">
        <h2 className="walk-in-list-title">Waitlist</h2>
        <div className="walk-in-list-header-right">
          <button type="button" className="walk-in-list-settings" onClick={onSettingsClick} aria-label="Settings">
            <Icon glyph={GLYPHS.settings} size="medium" style={{ color: 'var(--primaryColor)' }} />
          </button>
          <Button type="button" className="cta-btn cta-btn--blue" onClick={onAddWalkIn}>
            + Add walkin
          </Button>
        </div>
      </div>
    </div>
  );
};

WalkInListHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSettingsClick: PropTypes.func.isRequired,
  onAddWalkIn: PropTypes.func.isRequired,
};

export default WalkInListHeader;
